import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { listProductHotSale } from "../endpoints/product";
import { useBackendLang } from "../lang-context";
import type { ProductHotSaleInput } from "../path-adapter";

export function useHotSale(input: ProductHotSaleInput) {
  const lang = useBackendLang();
  return useQuery({
    queryKey: [
      "product",
      "hot-sale",
      input.channel,
      input.categoryId,
      input.keyword,
      input.pageNo,
      input.pageSize,
      input.sort,
      input.priceStart,
      input.priceEnd,
      lang,
    ],
    queryFn: () => listProductHotSale({ baseUrl: API_BASE_URL }, input, { lang }),
    staleTime: 60 * 1000,
  });
}
